import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBookOpen, faMusic } from '@fortawesome/free-solid-svg-icons';
import { AudioContext } from '../contexts/AudioContext';
import { ProgressStatus } from '../db';
import {
  loadPlan,
  planDayNumber,
  firstUnread,
  daysBehind,
  toPlayable,
} from '../utils/plan';
import './PlanTab.css';

const ICONS = {
  old_testament: faBook,
  new_testament: faBookOpen,
  poetry: faMusic,
};

function formatDelta(delta) {
  if (delta === 0) return 'on time';
  if (delta > 0) return `${delta} day${delta === 1 ? '' : 's'} behind`;
  const ahead = -delta;
  return `${ahead} day${ahead === 1 ? '' : 's'} ahead`;
}

function PlanTab({ closeMenu }) {
  const { chapterProgress, setCurrentChapter, setIsPlaying, updateSession } =
    useContext(AudioContext);
  const [sections, setSections] = useState([]);
  const todayDay = planDayNumber();

  useEffect(() => {
    let cancelled = false;
    loadPlan()
      .then((plan) => {
        if (cancelled) return;
        setSections(['old_testament', 'new_testament', 'poetry'].map((id) => plan.sections[id]));
      })
      .catch((err) => console.error('Failed to load plan', err));
    return () => {
      cancelled = true;
    };
  }, []);

  const startSection = (section) => {
    const unread = firstUnread(section, chapterProgress);
    if (!unread) return;
    const playable = toPlayable(unread, section.id);
    setCurrentChapter(playable);
    setIsPlaying(true);
    updateSession(playable);
    closeMenu(true);
  };

  return (
    <div className="plan-tab">
      {sections.map((section) => {
        if (!section) return null;
        const unread = firstUnread(section, chapterProgress);
        const delta = unread ? daysBehind(unread, todayDay) : 0;
        const inProgress =
          unread &&
          chapterProgress[`${unread.bookId}:${unread.chapter}`]?.status ===
            ProgressStatus.IN_PROGRESS;
        const action = !unread ? 'Done' : inProgress ? 'Continue' : 'Start';
        const where = unread ? `${unread.book} ${unread.chapter}` : 'Finished';
        return (
          <button
            key={section.id}
            type="button"
            className={`plan-card ${unread ? '' : 'plan-card-done'}`}
            onClick={() => startSection(section)}
            disabled={!unread}
          >
            <FontAwesomeIcon icon={ICONS[section.id] || faBook} className="plan-card-icon" />
            <div className="plan-card-body">
              <div className="plan-card-label">{section.label}</div>
              <div className="plan-card-where">
                {action}: {where}
              </div>
            </div>
            <div className={`plan-card-delta ${delta > 0 ? 'behind' : delta < 0 ? 'ahead' : 'ontime'}`}>
              {unread ? formatDelta(delta) : ''}
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default PlanTab;
